// Verbatim port of TOOLS16 (~881-889) from docs/discovery-calculator.dc.html; DEFAULT_TOOLS16
// mirrors the `tools16` state seed (~636) also used as the import/restore fallback (~1781, 1797).

import type { Tool16 } from '../types';

export const TOOLS16: Tool16[] = [
  { id: 'zoominfo', name: 'ZoomInfo', icon: 'assets/provider-icons/ZoomInfo.svg', def: 60000 },
  { id: 'apollo', name: 'Apollo', icon: 'assets/provider-icons/Apollo.svg', def: 24000 },
  { id: 'sixsense', name: '6sense', icon: 'assets/provider-icons/6Sense.svg', def: 60000 },
  { id: 'lusha', name: 'Lusha', icon: 'assets/provider-icons/Lusha.svg', def: 15000 },
  { id: 'clearbit', name: 'Clearbit', icon: 'assets/provider-icons/Clearbit.svg', def: 20000 },
  { id: 'leadiq', name: 'LeadIQ', icon: 'assets/provider-icons/LeadIQ.svg', def: 10000 },
  { id: 'outreach', name: 'Outreach', icon: 'assets/provider-icons/Outreach.svg', def: 30000 },
];

/** The ticked-tools seed: ZoomInfo on at its default contract value. */
export const DEFAULT_TOOLS16: Record<string, number | ''> = { zoominfo: 60000 };
